<template>
  <Tippy arrow placement="top" max-width="200">
    <template #trigger>
      <slot />
    </template>
    <div class="plan-tunnel-default-additionnal-hour-tooltip">
      <div>
        <f-icon icon="fa6-circle-info" inline></f-icon>
      </div>
      <div class="text">
        {{ $vt("Additional hours can be bought at any time. They can be used for the entire duration of the plan") }}
      </div>
    </div>
  </Tippy>
</template>
<script>
export default {

}
</script>

<style lang="scss">
.plan-tunnel-default-additionnal-hour-tooltip {
    display: flex;
    flex-direction: row;
    gap: 8px;

    justify-content: center;
    align-items: center;


    :last-child {
        text-align: left;
        max-width: 25ch;
    }
}
</style>